{
  "nl": {
    "common": {
      "search": "Zoeken",
      "selected": "Geselecteerd"
    }
  }
}
